/* global BX, FormUtils */

window.initRegistrationForm = function (formId) {
    const formSelector = '#' + formId;
    const registrationForm = document.getElementById(formId);

    if (!registrationForm) return null;

    let activeTimer = false;

    const phoneInput = registrationForm.querySelector('#input_PERSONAL_PHONE');
    const checkBtn = registrationForm.querySelector('#check_phone');
    const form = registrationForm;
    const smsInputWrapper = registrationForm.querySelector('.input_phone');
    const smsInput = registrationForm.querySelector('#input_check_phone');
    const smsAlert = registrationForm.querySelector('.sms_alert');
    const timerNode = registrationForm.querySelector('.time_to_end');
    const submitBtn = registrationForm.querySelector('#main_submit_btn');
    let errorBlock = document.querySelector('.form-common-errors');

    const confirmedHiddenInput = registrationForm.querySelector('#input_PHONE_CONFIRMED');
    const isPhoneConfirmed = confirmedHiddenInput && confirmedHiddenInput.value === 'Y';

    function clearPhoneState() {
        FormUtils.clearFieldError(phoneInput);
        clearCommonError();
        registrationForm.querySelectorAll('.phone-success').forEach((el) => el.remove());
    }

    function clearCommonError() {
        if (!errorBlock) return;
        while (errorBlock.lastChild) {
            errorBlock.removeChild(errorBlock.lastChild);
        }
        errorBlock.style.display = 'none';
    }

    function clearAll() {
        FormUtils.clearFieldErrors(formSelector);
        clearCommonError();
    }

    function phoneSuccess() {
        if (!phoneInput) return;

        FormUtils.clearFieldError(phoneInput);

        const wrap = phoneInput.closest('div[style*="position: relative"]') || phoneInput.closest('div');
        if (!wrap) return;

        registrationForm.querySelectorAll('.phone-success').forEach((el) => el.remove());

        const ok = document.createElement('span');
        ok.className = 'phone-success';
        ok.innerHTML = '<i class="fa big-icon s25 fa-check-square"></i>';

        wrap.appendChild(ok);
    }

    if (isPhoneConfirmed && phoneInput) {
        phoneInput.setAttribute('readonly', 'readonly');
        phoneInput.disabled = false;
        phoneSuccess();
        if (submitBtn) submitBtn.disabled = false;
    } else if (phoneInput) {
        FormUtils.setupPhoneMask(phoneInput);
        phoneInput.addEventListener('input', () => {
            FormUtils.clearFieldErrors(formSelector);
        });
    }

    function validatePhone(phone) {
        const digits = phone.replace(/\D/g, '');
        return digits.length === 11 && digits.startsWith('7');
    }

    function startTimer() {
        let count = 180;

        smsInputWrapper?.classList.remove('hidden');
        if (checkBtn) checkBtn.disabled = true;
        activeTimer = true;
        if (phoneInput) phoneInput.readOnly = true;

        if (smsAlert) smsAlert.classList.remove('hidden');
        if (timerNode) timerNode.textContent = count;

        const timer = setInterval(() => {
            count--;
            if (timerNode) timerNode.textContent = count;

            if (count <= 0) {
                clearInterval(timer);
                activeTimer = false;
                if (checkBtn) checkBtn.disabled = false;
                if (phoneInput) phoneInput.readOnly = false;
                if (smsAlert) smsAlert.classList.add('hidden');
            }
        }, 1000);
    }

    checkBtn?.addEventListener('click', function () {
        if (activeTimer) return;

        clearPhoneState();
        const phone = phoneInput?.value || '';

        if (!phone) {
            FormUtils.showFieldError(phoneInput, '*Обязательное поле');
            return;
        }

        if (!validatePhone(phone)) {
            FormUtils.showFieldError(phoneInput, '*Неверный формат');
            return;
        }

        BX.ajax({
            url: '/ajax/verification_sms.php',
            method: 'POST',
            dataType: 'json',
            data: {
                phone: phone,
                stoken: window?.token1 ?? null,
                hashKey: window?.[window.functionName]?.(BX.bitrix_sessid),
                sessid: BX.bitrix_sessid(),
            },
            onsuccess: function (res) {
                if (!res || res.success !== true) {
                    let errorText = '*Ошибка';
                    switch (res?.error) {
                        case 'exist':
                            errorText = '*Номер уже используется';
                            break;
                        case 'processed or banned':
                            errorText = '*Запрос в обработке';
                            break;
                        case 'format error':
                            errorText = '*Некорректное значение';
                            break;
                    }
                    FormUtils.showFieldError(phoneInput, errorText);
                    return;
                }
                startTimer();
            },
            onfailure: function () {
                FormUtils.showFieldError(phoneInput, '*Ошибка отправки SMS');
            },
        });
    });

    smsInput?.addEventListener('blur', function (e) {
        clearPhoneState();

        const code = e.target.value;
        const phone = phoneInput?.value;

        if (!code || !phone) return;

        if (code.length !== 6) {
            FormUtils.showFieldError(smsInput, '*Код подтверждения состоит из 6 символов');
            return;
        }

        BX.ajax({
            url: '/ajax/verification_sms.php',
            method: 'POST',
            dataType: 'json',
            data: {
                phone: phone,
                vtoken: window?.token2 ?? null,
                verificationCode: code,
                hashKey: window?.[window.functionName]?.(BX.bitrix_sessid),
                sessid: BX.bitrix_sessid(),
            },
            onsuccess: function (res) {
                if (res?.success === true) {
                    phoneSuccess();
                    if (confirmedHiddenInput) {
                        confirmedHiddenInput.value = 'Y';
                    }

                    if (submitBtn) {
                        submitBtn.disabled = false;
                        submitBtn.removeAttribute('disabled');
                    }

                    smsInputWrapper?.remove();

                    const parent = checkBtn?.closest('.registration-form__row--poz');
                    if (parent) parent.remove();
                    else checkBtn?.remove();

                    smsAlert?.remove();
                    phoneInput?.setAttribute('readonly', 'readonly');
                } else {
                    FormUtils.showFieldError(smsInput, '*Неверный код подтверждения');
                    e.target.focus();
                }
            },
            onfailure: function () {
                FormUtils.showFieldError(smsInput, '*Ошибка проверки кода');
            },
        });
    });

    form?.addEventListener('input', function (e) {
        if (e.target.name !== 'input_check_phone') return;
        if (e.target.value.length === 6) {
            e.target.blur();
        }
    });

    return {
        validateBaseFields: function () {
            clearAll();

            let hasError = false;
            let commonError = false;

            const isConfirmedNow = confirmedHiddenInput && confirmedHiddenInput.value === 'Y';
            if (!isConfirmedNow) {
                hasError = true;
                if (errorBlock) {
                    commonError = true;
                    FormUtils.showCommonError(errorBlock, '*Подтвердите телефон');
                }
            }

            const passInp = registrationForm.querySelector('#input_PASSWORD');
            const confirmInp = registrationForm.querySelector('#input_CONFIRM_PASSWORD');

            if (passInp && passInp.value.length < 6) {
                hasError = true;
                FormUtils.showFieldError(passInp, '*Пароль должен быть не менее 6 символов');
            }

            if (confirmInp && confirmInp.value.length < 6) {
                hasError = true;
                FormUtils.showFieldError(confirmInp, '*Пароль должен быть не менее 6 символов');
            }

            if (passInp && confirmInp && passInp.value !== confirmInp.value) {
                hasError = true;
                FormUtils.showFieldError(confirmInp, '*Пароли не совпадают');
            }

            if (hasError && errorBlock && commonError) {
                errorBlock.style.display = 'block';
            }

            return !hasError;
        },
    };
};

document.addEventListener('DOMContentLoaded', function () {
    const subscribe = document.getElementById('input_subscribe_status');
    subscribe?.addEventListener('change', function (e) {
        const hidden = document.getElementById('input_UF_SUBSCRIBE_STATUS');
        if (!hidden) return;
        hidden.value = e.target.checked ? 'Y' : 'N';
    });
});
